import type { TRuleWithTheme } from '@/styles/theme';

export const text: TRuleWithTheme = () => ({
    marginTop: '0.5rem',
    marginBottom: '1.5rem',
});
